// extracted by mini-css-extract-plugin
export default {"popupWrapper":"GroupedPopup_popupWrapper__9P1Xk","parentDiv":"GroupedPopup_parentDiv__GoRgq","contentDiv":"GroupedPopup_contentDiv__waRms","imageBg":"GroupedPopup_imageBg__YffeX"};